import { defineService } from '@nzyme/ioc/Service.js';
import { createAsyncCache } from '@nzyme/utils/createAsyncCache.js';
import type { Id } from '@sigma/common/schema/Id.js';
import { StaffGetEndpoint } from '@sigma/patient-api/staff/StaffGetEndpoint.js';

import { ApiClient } from './ApiClient.js';

/** Patient-app staff data cache, used wherever a staff record needs to be resolved by id. */
export const StaffStore = defineService({
    name: 'StaffStore',
    deps: {
        apiClient: ApiClient,
    },
    setup({ apiClient }) {
        const cache = createAsyncCache({
            getValue: (id: Id) => apiClient(StaffGetEndpoint, { id }),
        });

        return {
            get: cache.get,
        };
    },
});
